import { timeAgo } from "./utility";

export const getLastUpdatedLabel = (
  isLoading: boolean,
  isSaving: boolean,
  lastSavedAt?: Date,
): string => {
  if (isLoading) {
    return "loading...";
  }

  if (isSaving) {
    return "saving...";
  }

  return lastSavedAt ? timeAgo(lastSavedAt) : "loading...";
};
